import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

const LANG_KEY = 'niretxoko.lang';

export type Idioma = 'es' | 'eu';

/** Idiomas disponibles en la web pública (es/eu, extensible). */
export const IDIOMAS: { codigo: Idioma; nombre: string }[] = [
  { codigo: 'es', nombre: 'Español' },
  { codigo: 'eu', nombre: 'Euskara' },
];

/**
 * Servicio de i18n de la web pública: idioma activo con `signal` + `TranslateService`
 * + `localStorage`. Adaptado a SSR: solo lee/guarda en el navegador.
 */
@Injectable({ providedIn: 'root' })
export class LangService {
  readonly actual = signal<Idioma>('es');

  private readonly translate = inject(TranslateService);
  private readonly platformId = inject(PLATFORM_ID);

  constructor() {
    const idioma = this.inicial();
    this.actual.set(idioma);
    this.translate.use(idioma);
  }

  /** Cambia el idioma activo: actualiza `TranslateService`, la `signal` y persiste. */
  usar(idioma: Idioma): void {
    this.translate.use(idioma);
    this.actual.set(idioma);
    if (isPlatformBrowser(this.platformId)) {
      window.localStorage.setItem(LANG_KEY, idioma);
    }
  }

  private inicial(): Idioma {
    if (isPlatformBrowser(this.platformId)) {
      const guardado = window.localStorage.getItem(LANG_KEY);
      if (guardado === 'es' || guardado === 'eu') {
        return guardado;
      }
      return window.navigator.language?.toLowerCase().startsWith('eu') ? 'eu' : 'es';
    }
    return 'es';
  }
}
